export const EDIT_REASON_DIALOG_HEADER = 'Edit CIC reason';

export const CHANGE_LABEL = 'Change';

export const FEE_LABEL = 'Fee';

export const ENTERED_BY_LABEL = 'Entered by';

export const REASON_LABEL = 'Reason';

export const REASON_PLACEHOLDER = 'Select a reason';

export const COMMENT_LABEL = 'Comment';

export const COMMENT_HELPER_TEXT = 'Required, 1–500 characters';

export const LOG_NOTE = 'Your edit is added to this log. The original is never overwritten.';

export const CANCEL_BUTTON_LABEL = 'Cancel';

export const CLOSE_BUTTON_LABEL = 'Close';

export const SAVE_BUTTON_LABEL = 'Save reason';

export const PENDING_DISCLOSURE_SUFFIX = 'pending disclosure';

export const CONFLICT_MESSAGE =
  'This change has already gone out on a disclosure, so its reason can no longer be edited. The CIC history has been refreshed.';

export const FEE_CONFLICT_MESSAGE =
  'This fee change has already gone out on a disclosure, or another pending change to this fee already uses the chosen reason, so it can no longer be saved. The CIC history has been refreshed.';

export const LOAD_REASONS_ERROR_MESSAGE = "Couldn't load the CIC reasons. Close and try again.";

export const SAVE_ERROR_MESSAGE = "Couldn't save the reason. Try again.";

export const INACTIVE_REASON_MESSAGE =
  'The current reason is no longer active. Choose another reason to save a change.';
